import CounsellingHomeHeaderSkeleton from './CounselingHomeHeaderSkeleton'
import CounsellingProfilesListSkeleton from './CounsellingProfilesListSkeleton'

const CounsellingLeftSideSkeleton = () => {
    return (
        <div className="animate-pulse flex-1">
            {/* Tracker section */}
            <div className="well-tracker-container">
                {/* Header */}
                <CounsellingHomeHeaderSkeleton />
                {/* List of profile cards */}
                <div className="well-tracker-list light-small-scroll flex flex-col pr-[18px]">
                    <CounsellingProfilesListSkeleton />
                </div>
            </div>
        </div>
    )
}

export default CounsellingLeftSideSkeleton
